import React from 'react';
import { Link } from 'react-router-dom';
import LocationLandingPage from './LocationLandingPage';

const GypsumCeilingsNairobi = () => (
  <LocationLandingPage
    title="Gypsum Ceilings in Nairobi | Design, Supply & Installation"
    description="Professional gypsum ceiling services in Nairobi with modern designs, durable boards, lighting integration, and skilled installation for homes and commercial interiors."
    path="/gypsum-ceilings-nairobi"
    h1="Gypsum Ceilings Nairobi"
    intro="Upgrade your interiors with custom gypsum ceiling systems designed for modern living spaces, offices, and commercial projects in Nairobi."
    serviceType="Gypsum ceiling design and installation"
    highlights={[
      'Decorative and modern gypsum ceiling designs',
      'Moisture-resistant and standard board options',
      'Integrated lighting details for premium finishes',
      'Installation for homes, offices, and retail spaces',
      <>
        Browse gypsum products: <Link to="/category/1">shop gypsum ceilng</Link>
      </>,
    ]}
    faqs={[
      {
        question: 'How much do gypsum ceilings cost in Nairobi?',
        answer: 'Pricing depends on design complexity, ceiling area, and board specification. We provide detailed project-specific quotations.',
      },
      {
        question: 'How long does installation take?',
        answer: 'Most standard rooms are completed within a few days, while larger or custom installations require more time.',
      },
    ]}
    pricingTitle="Gypsum Ceiling Prices in Nairobi"
    pricingIntro="Gypsum ceiling prices vary depending on design, materials, and complexity."
    pricingItems={[
      { name: 'Standard gypsum ceiling', price: 'KES 1,800 - 2,500 per sqm' },
      { name: 'Decorative ceiling with lighting', price: 'KES 2,500 - 4,500 per sqm' },
      { name: 'Bulkheads and custom designs', price: 'KES 3,000 - 6,000 per sqm' },
    ]}
    pricingCta={
      <>
        <Link to="/category/1" className="location-cta-button">Shop gypsum ceiling</Link>{' '}
        <Link to="/contact-us">Contact us</Link> for an accurate quotation based on your space and design.
      </>
    }
  />
);

export default GypsumCeilingsNairobi;
